import { Row } from "antd";
import React, { useEffect, useRef } from "react";
import { ROUTER_PATH, WIDTH_MOBILE } from "../../common/constant";
import { ISectionCSS } from "../../models/interface/ISectionCSS";
import { localizeRouteKey } from "../../shared/helpers";

const CategoryInfoItem = (props: any) => {
  const { categoryInfo, index, history, tl, isNeedScrollTrigger, isShowHome } =
    props;
  const { innerWidth } = window;
  const el: any = useRef(null);

  useEffect(() => {
    if (tl && isNeedScrollTrigger) {
      tl.from(el.current, { x: innerWidth * 1 }, index * 0.1);
    }
  }, [tl, index]);

  const colorStyle: ISectionCSS = {
    "--colorTitleChild": categoryInfo.color_title
      ? categoryInfo.color_title
      : "#0c3b5d",
  };

  const handleClick = async () => {
    if (categoryInfo.url && isShowHome) {
      history.push(localizeRouteKey(ROUTER_PATH.CATEGORY) + categoryInfo.url);
    } else if (categoryInfo.url && !isShowHome) {
      const el: any = document.getElementById(categoryInfo.url.toString());
      el?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <a
      ref={el}
      style={colorStyle}
      onClick={handleClick}
      className={`category-info-item-wrapper ${
        index % 2 === 0 ? "" : "item-down"
      }`}>
      <Row className="category-info-item-media">
        <img
          src={
            categoryInfo.images &&
            categoryInfo.images.length &&
            categoryInfo.images[0].galaries[0].path
          }
          alt=""
        />
        {innerWidth > WIDTH_MOBILE ? (
          <video autoPlay muted loop className="category-info-video">
            <source
              src={
                categoryInfo.video &&
                categoryInfo.video.length &&
                categoryInfo.video[0].galaries[0].path
              }
              type="video/mp4"
            />
          </video>
        ) : null}
      </Row>
      <Row className="category-info-item-title main-content">
        {categoryInfo?.title}
      </Row>
      {/* <Row className="sub-content">{categoryInfo?.sub_title}</Row> */}
    </a>
  );
};

export default CategoryInfoItem;
